"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";

export function ExploreCityLink({
  cityLink = {
    href: "#",
  },

  cityNameText = "City",
}) {
  return (
    <Link
      block={"inline"}
      button={false}
      className={"explore_city-link"}
      options={cityLink}
    >
      <Block className={"text-block-5"} tag={"div"}>
        {cityNameText}
      </Block>
      <HtmlEmbed
        className={"icon-embed-xxsmall"}
        content={
          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--ic" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/></svg>'
        }
      />
    </Link>
  );
}
